import React from 'react';
import { StructuredData } from './StructuredData';
/** Renders structured product data using Schema.org vocab */
const StructuredPageData = ({ page, extraFields = {} }) => {
    var _a, _b, _c, _d;
    const baseWebPageData = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: page.name,
        primaryImageOfPage: (_b = (_a = page.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url,
        image: (_d = (_c = page.images) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.url
    };
    const withInjectedPageData = Object.assign(Object.assign({}, baseWebPageData), extraFields);
    return React.createElement(StructuredData, { json: withInjectedPageData });
};
export { StructuredPageData };
//# sourceMappingURL=StructuredPageData.js.map